"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findPeriodName = void 0;
const lodash_1 = require("lodash");
const dayjs = require("dayjs");
const DEFAULT_PERIOD = 'low';
function findPeriodName(pricingPeriods, occurenceDate) {
    try {
        const occurenceDayjs = dayjs(occurenceDate);
        const year = occurenceDayjs.year();
        const periods = pricingPeriods[year];
        const exception = periods === null || periods === void 0 ? void 0 : periods.exceptions.find((exception) => occurenceDayjs.isSame(exception.date, 'day'));
        if (!lodash_1.isEmpty(exception === null || exception === void 0 ? void 0 : exception.forcePeriodName)) {
            return exception.forcePeriodName;
        }
        const period = periods === null || periods === void 0 ? void 0 : periods.periods.find((period) => occurenceDayjs.isBetween(period.startDate, period.endDate));
        return (period === null || period === void 0 ? void 0 : period.name) || DEFAULT_PERIOD;
    }
    catch (e) {
        console.error('Find period name error', e);
        return DEFAULT_PERIOD;
    }
}
exports.findPeriodName = findPeriodName;
//# sourceMappingURL=periods.js.map